export default "__VITE_ASSET__BX4r4QoE__"